export default "__VITE_ASSET__DIZbRVBW__"